module.exports = __webpack_public_path__ + "static/brokerage-accounts-services-hero-mobile.3e5fb7be.webp";